// @core/api/endpoints/localization/update_translation_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TranslationKeyResponse,
  UpdateTranslationKeyRequest,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Update translation key
 * Updates a translation key's source text, description, or metadata. Changing source_text marks existing translations as NEEDS_UPDATE.
 */
export async function UpdateTranslationKey(
  key_id: string,
  data: UpdateTranslationKeyRequest,
  options?: RequestOptions
): Promise<TranslationKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/keys/:key_id`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.put<TranslationKeyResponse>(requestPath, data, requestOptions);
}
